import api from "./axios-client.js";

export const getProfile = async () => {
    try {
        const response = await api.get('/profile');
        return response.data;
    } catch (err) {
    }
}

export const updateUserProfile = async (userData: any) => {
    try {
        const response = await api.put('/user', userData);
        return response.data;
    } catch (err) {
        throw err;
    }
}

export const changeUserPassword = async (userData: any) => {
    try {
        const response = await api.post('/change-password', userData);
        return response.data;
    } catch (err: any) {
        if (err.response && err.response.data) {
            throw err.response.data;
        }
        throw err;
    }
}
